module.exports = __webpack_public_path__ + "img/programme7.0b9f66f2.png";